import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import useGetLocationOptions from '../../locations/queries/useGetLocationOptions';

const SBCLocationDropdown = ({ darkMode, values, setFieldValue }) => {
    const { data: locations = [], isLoading } = useGetLocationOptions();

    const handleSelectChange = (item) => {
        setFieldValue('locationID', item?.id || '');
    };

    return (
        <FormControl isRequired sx={{ margin: '0 !important' }}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>Location</FormLabel>
                <Box flex={1} maxWidth="400px">
                    <DropDown
                        name="locationID"
                        data={locations}
                        shownValue="location"
                        currentId={values?.locationID}
                        selectedId="id"
                        isLoading={isLoading}
                        placeholder="- Select Location -"
                        darkMode={darkMode}
                        handleSelectChange={handleSelectChange}
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default SBCLocationDropdown;
